module.exports = __webpack_public_path__ + "static/media/workingmemory-words-8.c94f83c0.mp3";